import * as d3 from 'd3'

export default {
  methods: {

    draw_Chart() {

      let title = this.title
      let db = this.schedule.data
      let act = this.schedule.actual
      let delta = this.schedule.delta
      let cht = this.chart

      let x_ = 0, y_ = 0

      let totleArea = this.canvasForms
      .append('g')
      .attr('transform', `translate(0, 0)`)

      if(title.visible=='Y') {
        this.draw_Text(totleArea, '', 0, title.tSize/2,  title.tSize, title.tColor, 'start', title.name)
        this.funcY = title.height
      }
      
      let data = this.rawData.find(f=> f[db.code] == db.value)
      if(this.schedule.visible != 'Y' || data == undefined) return

      let chartArea = this.canvasForms
      .append('g')
      .attr('transform', `translate(0, ${this.funcY})`)

      // Actual - Cumulative
      y_ = act.tSize/2
      this.draw_Text(chartArea, `AC_CUM_${this.localId}`, 0, y_,  act.tSize, '#333', 'start', 'Cumulative')
      this.draw_Text(chartArea, '', this.getNode(`#AC_CUM_${this.localId}`, 'width') + 5, y_,  act.tSize, act.tColor, 'start', `(${data.AC_CUM}%)`)

      // Actual - This Week
      let actWeek = chartArea
      .append('g')
      .attr('id', `THISWEEK_CUM_${this.localId}`)
      .attr('transform', `translate(0, ${y_})`)

      this.draw_Text(actWeek, `AC_WK_${this.localId}`, 0, 0,  act.tSize, '#333', 'start', 'This Week')
      this.draw_Text(actWeek, '', this.getNode(`#AC_WK_${this.localId}`, 'width') + 5, 0,  act.tSize, act.tColor, 'start', `(${data.AC_WK}%)`)


      // Delta - Cumulative - Early ------------------------------------------------------------------------------------------------------------------------------------------------------------
      y_ = act.tSize + this.schedule.lineGap + (delta.tSize/2)

      let cumEarly = chartArea
      .append('g')
      .attr('transform', `translate(0, ${y_})`)

      this.draw_Text(cumEarly, `CUM_EARLY_${this.localId}`, 0, 0,  delta.tSize, '#333', 'start', 'Early')

      x_ = this.getNode(`#CUM_EARLY_${this.localId}`, 'width') + 5
      this.draw_Text(cumEarly, `PE_CUM_${this.localId}`, x_, 0,  delta.tSize, delta.tColor, 'start', `${data.PE_CUM}%`)

      x_ = this.getNode(`#CUM_EARLY_${this.localId}`, 'width') + 5 + this.getNode(`#PE_CUM_${this.localId}`, 'width') + 10
      this.draw_Text(cumEarly, `DE_CUM_${this.localId}`, x_, 0,  delta.tSize, this.gmx_deltaValue(data.DE_CUM), 'start', `${data.DE_CUM}%`)

      x_ = this.getNode(`#CUM_EARLY_${this.localId}`, 'width') + 5 + this.getNode(`#PE_CUM_${this.localId}`, 'width') + 10 + this.getNode(`#DE_CUM_${this.localId}`, 'width') + 2
      cumEarly // Icon
       .append('path')
       .attr('transform', `translate(${x_}, ${-delta.tSize/2}) scale(.7)`)
       .attr('d', this.gmx_deltaValue(data.DE_CUM, 'icon'))
       .attr('fill', this.gmx_deltaValue(data.DE_CUM))


       // Delta - Cumulative - Late
       x_ = x_ + 25
       let cumLate = chartArea
      .append('g')
      .attr('transform', `translate(${x_}, ${y_})`)

      this.draw_Text(cumLate, `CUM_LATE_${this.localId}`, 0, 0,  delta.tSize, '#333', 'start', 'Late')

      x_ = this.getNode(`#CUM_LATE_${this.localId}`, 'width') + 5
      this.draw_Text(cumLate, `PL_CUM_${this.localId}`, x_, 0,  delta.tSize, delta.tColor, 'start', `${data.PL_CUM}%`)

      x_ = this.getNode(`#CUM_LATE_${this.localId}`, 'width') + 5 + this.getNode(`#PL_CUM_${this.localId}`, 'width') + 10
      this.draw_Text(cumLate, `DL_CUM_${this.localId}`, x_, 0,  delta.tSize, this.gmx_deltaValue(data.DL_CUM), 'start', `${data.DL_CUM}%`)

      x_ = this.getNode(`#CUM_LATE_${this.localId}`, 'width') + 5 + this.getNode(`#PL_CUM_${this.localId}`, 'width') + 10 + this.getNode(`#DL_CUM_${this.localId}`, 'width') + 2
      cumLate // Icon
       .append('path')
       .attr('transform', `translate(${x_}, ${-delta.tSize/2}) scale(.7)`)
       .attr('d', this.gmx_deltaValue(data.DL_CUM, 'icon'))
       .attr('fill', this.gmx_deltaValue(data.DL_CUM))


       // Delta - This Week - Early ------------------------------------------------------------------------------------------------------------------------------------------------------------
       let thisWeek = chartArea
       .append('g')
       .attr('id', `THISWEEK_SCH_${this.localId}`)
       .attr('transform', `translate(0, ${y_})`)

      let thisEarly = thisWeek
      .append('g')
      .attr('transform', `translate(0, 0)`)

      this.draw_Text(thisEarly, `WK_EARLY_${this.localId}`, 0, 0,  delta.tSize, '#333', 'start', 'Early')

      x_ = this.getNode(`#WK_EARLY_${this.localId}`, 'width') + 5
      this.draw_Text(thisEarly, `PE_WK_${this.localId}`, x_, 0,  delta.tSize, delta.tColor, 'start', `${data.PE_WK}%`)

      x_ = this.getNode(`#WK_EARLY_${this.localId}`, 'width') + 5 + this.getNode(`#PE_WK_${this.localId}`, 'width') + 10
      this.draw_Text(thisEarly, `DE_WK_${this.localId}`, x_, 0,  delta.tSize, this.gmx_deltaValue(data.DE_WK), 'start', `${data.DE_WK}%`)

      x_ = this.getNode(`#WK_EARLY_${this.localId}`, 'width') + 5 + this.getNode(`#PE_WK_${this.localId}`, 'width') + 10 + this.getNode(`#DE_WK_${this.localId}`, 'width') + 2
      thisEarly // Icon
      .append('path')
      .attr('transform', `translate(${x_}, ${-delta.tSize/2}) scale(.7)`)
      .attr('d', this.gmx_deltaValue(data.DE_WK, 'icon'))
      .attr('fill', this.gmx_deltaValue(data.DE_WK))


       // Delta - Cumulative - Late
       x_ = x_ + 25
       let thisLate = thisWeek
      .append('g')
      .attr('transform', `translate(${x_}, 0)`)

      this.draw_Text(thisLate, `WK_LATE_${this.localId}`, 0, 0,  delta.tSize, '#333', 'start', 'Late')

      x_ = this.getNode(`#WK_LATE_${this.localId}`, 'width') + 5
      this.draw_Text(thisLate, `PL_WK_${this.localId}`, x_, 0,  delta.tSize, delta.tColor, 'start', `${data.PL_WK}%`)

      x_ = this.getNode(`#WK_LATE_${this.localId}`, 'width') + 5 + this.getNode(`#PL_WK_${this.localId}`, 'width') + 10
      this.draw_Text(thisLate, `DL_WK_${this.localId}`, x_, 0,  delta.tSize, this.gmx_deltaValue(data.DL_WK), 'start', `${data.DL_WK}%`)

      x_ = this.getNode(`#WK_LATE_${this.localId}`, 'width') + 5 + this.getNode(`#PL_WK_${this.localId}`, 'width') + 10 + this.getNode(`#DL_WK_${this.localId}`, 'width') + 2
      thisLate // Icon
      .append('path')
      .attr('transform', `translate(${x_}, ${-delta.tSize/2}) scale(.7)`)
      .attr('d', this.gmx_deltaValue(data.DL_WK, 'icon'))
      .attr('fill', this.gmx_deltaValue(data.DL_WK))

      // 
      let getX = this.header.width - this.getNode(`#THISWEEK_SCH_${this.localId}`, 'width')
      d3.select(`#THISWEEK_CUM_${this.localId}`).attr('transform', `translate(${getX}, ${act.tSize/2})`)
      d3.select(`#THISWEEK_SCH_${this.localId}`).attr('transform', `translate(${getX}, ${y_})`)


      // Bar Chart ------------------------------------------------------------------------------------------------------------------------------------------------------------
      if(cht.visible == 'Y') {
        let proLen = (data.AC_CUM/100) * this.header.width
        y_ = act.tSize + this.schedule.lineGap + delta.tSize + this.schedule.lineGap
      
        let barChart = chartArea
        .append('g')
        .attr('id', `THISWEEK_SCH_${this.localId}`)
        .attr('transform', `translate(0, ${y_})`)

        barChart
        .append('rect')
        .attr('x', 0).attr('x', 0)
        .attr('rx', cht.radius)
        .attr('width', this.header.width).attr('height', cht.height)
        .attr('fill', '#F4F5F5')

        barChart
        .append('rect')
        .attr('x', 0).attr('x', 0)
        .attr('rx', cht.radius).attr('opacity', cht.opacity)
        .attr('width', proLen).attr('height', cht.height)
        .attr('fill', `url(#${this.localId}_${this.chart.color}_0)`)

        if(data.AC_CUM < 80) 
          this.draw_Text(barChart, ``, proLen + 2, cht.height/2+1,  cht.tSize, cht.tColor, 'start', `${data.AC_CUM}%`)
        else 
          this.draw_Text(barChart, ``, proLen - 2, cht.height/2+1,  cht.tSize, cht.tColor, 'end', `${data.AC_CUM}%`)
      }

      this.funcY = title.height + this.schedule.height
    },









    
  }
}